import { UrlParams } from '@/common/enums';
import { getUrlParam } from '@/common/utils';
import MainMenuOptionValues from '../constants/MainMenuOptionValues';
import type { MainMenuOption } from '../types';

const InitialTabValues = {
  STATS: 'statistics',
  TABLE: 'table',
  PLAYERS: 'players',
  LINEUP: 'lineup',
} as const;

type InitialTabValueType = (typeof InitialTabValues)[keyof typeof InitialTabValues];

const initialTabToMenuOptionMap: Record<InitialTabValueType, MainMenuOption> = {
  [InitialTabValues.STATS]: MainMenuOptionValues.STATS,
  [InitialTabValues.TABLE]: MainMenuOptionValues.TABLE,
  [InitialTabValues.PLAYERS]: MainMenuOptionValues.PLAYERS,
  [InitialTabValues.LINEUP]: MainMenuOptionValues.LINEUP,
};

const isValidInitialTabValue = (value?: string): value is InitialTabValueType =>
  value !== undefined && Object.values(InitialTabValues).includes(value);

/**
 * Reads the `initialTab` URL query parameter and resolves the initial prematch
 * tab by matching the parameter value with one of the possible options (which
 * were agreed with the KSP team) and then maps it to our own MainMenuOption
 */
export default function getInitialPrematchMainMenuTabFromUrl(): MainMenuOption {
  const initialTab = getUrlParam(UrlParams.INITIAL_TAB);
  if (!initialTab) {
    return MainMenuOptionValues.STATS;
  }

  const lowercaseInitialTab = initialTab.toLocaleLowerCase();

  if (!isValidInitialTabValue(lowercaseInitialTab)) {
    return MainMenuOptionValues.STATS;
  }

  return initialTabToMenuOptionMap[lowercaseInitialTab];
}
